import { useState, useCallback, useEffect } from 'react';
import { EventData, EVENTS, STATUS, Step } from 'react-joyride';

const TOUR_KEY = 'solimat-management-tour-v1';

const STEPS: Step[] = [
  {
    target: '.mgmt-layout',
    title: 'Panel de gestiones',
    content: 'La pantalla está dividida en dos áreas: el menú de navegación (izquierda) para seleccionar la sección, y el área de contenido (derecha) donde se muestran los trámites disponibles.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '.mgmt-sidebar',
    title: 'Menú de secciones',
    content: 'Navega entre las distintas secciones de gestiones: trámites de la prestación activa, gestiones generales, autorizaciones y documentos.',
    placement: 'right',
    skipBeacon: true,
  },
  {
    target: '.mgmt-sidebar__group',
    title: 'Grupos de trámites',
    content: 'Los trámites están organizados por categorías. El número que aparece junto a cada sección indica cuántos trámites hay disponibles.',
    placement: 'right',
    skipBeacon: true,
  },
  {
    target: '.mgmt-sidebar__item',
    title: 'Seleccionar sección',
    content: 'Haz clic en cualquier sección para ver los trámites disponibles en el área de contenido. La sección seleccionada se resalta en el menú.',
    placement: 'right',
    skipBeacon: true,
  },
  {
    target: '.mgmt-content',
    title: 'Área de contenido',
    content: 'Aquí se muestran los trámites, formularios o documentos de la sección seleccionada. Haz clic en cualquier elemento para acceder a él.',
    placement: 'left',
    skipBeacon: true,
  },
];

export const useManagementTour = () => {
  const [run, setRun] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  const handleCallback = useCallback((data: EventData) => {
    const { type, status, index } = data as any;
    const finished = status === STATUS.FINISHED || status === STATUS.SKIPPED;

    if (finished || (type as string) === EVENTS.TOUR_END) {
      setRun(false);
      localStorage.setItem(TOUR_KEY, 'true');
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }

    if ((type as string) === EVENTS.STEP_AFTER && index === 0) {
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }
  }, []);

  const startTour = useCallback(() => {
    setRun(current => {
      if (current) return false;
      setTourKey(k => k + 1);
      return true;
    });
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: run } }));
  }, [run]);

  return { run, tourKey, steps: STEPS, handleCallback, startTour };
};
